export default "__VITE_ASSET__B3Wo5XHN__"